/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Elevation_One_LinerInputs */

const en_exp_elevation_one_liner = /** @type {(inputs: Exp_Elevation_One_LinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total meters climbed and descended during the session.`)
};

const de_exp_elevation_one_liner = /** @type {(inputs: Exp_Elevation_One_LinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamte Höhenmeter bergauf und bergab.`)
};

/**
* | output |
* | --- |
* | "Total meters climbed and descended during the session." |
*
* @param {Exp_Elevation_One_LinerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_elevation_one_liner = /** @type {((inputs?: Exp_Elevation_One_LinerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Elevation_One_LinerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_elevation_one_liner(inputs)
	return de_exp_elevation_one_liner(inputs)
});